import { Switch } from "@/components/ui/switch";

type MCAlertToggleProps = {
  title: string;
  description?: string;
  value: boolean;
  onChange: (value: boolean) => void;
  disabled?: boolean;
};

export function MCAlertToggle({ title, description, value, onChange, disabled }: MCAlertToggleProps) {
  return (
    <div className="flex items-start justify-between rounded-2xl border border-border bg-background/60 p-4">
      <div className="pr-4">
        <p className="text-sm font-semibold text-foreground">{title}</p>
        {description && <p className="text-xs text-muted-foreground">{description}</p>}
      </div>
      <Switch checked={value} onCheckedChange={onChange} disabled={disabled} />
    </div>
  );
}

export default MCAlertToggle;
